import { AxiosInstance } from 'axios';
import {
  AddCartItemBody,
  Cart,
  UpdateCartShippingTypeBody,
} from '@/api/carts/carts.types.ts';

export const createCartsApi = (api: AxiosInstance) => ({
  getCart: (contactEmployeeId: number) =>
    api.get<Cart>(`/v1/carts/${contactEmployeeId}`),

  upsertCartItem: (contactEmployeeId: number, cartItem: AddCartItemBody) =>
    api.post(`/v1/carts/${contactEmployeeId}`, cartItem),

  updateCartShippingType: (
    contactEmployeeId: number,
    cartShippingType: UpdateCartShippingTypeBody,
  ) =>
    api.post(`/v1/carts/${contactEmployeeId}/shipping-type`, cartShippingType),
});
